import { render, staticRenderFns } from "./WeeklyDistributions.vue?vue&type=template&id=6559f252&"
import script from "./WeeklyDistributions.vue?vue&type=script&lang=js&"
export * from "./WeeklyDistributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports